import type { User } from '@/types';

interface UserTableProps {
  users: User[];
  onEdit: (user: User) => void;
  onDelete: (user: User) => void;
  onToggleStatus: (id: string) => void;
}

export default function UserTable({ users, onEdit, onDelete, onToggleStatus }: UserTableProps) {
  if (users.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-portal-gray-200 p-12 text-center">
        <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-portal-gray-100 flex items-center justify-center">
          <i className="ri-user-search-line text-portal-gray-400 text-xl"></i>
        </div>
        <p className="text-sm font-medium text-portal-gray-500">Nenhum usuário encontrado</p>
        <p className="text-xs text-portal-gray-400 mt-1">Tente ajustar os filtros ou cadastrar um novo usuário.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-portal-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-portal-gray-100">
              <th className="text-left text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">Nome</th>
              <th className="text-left text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">CPF</th>
              <th className="text-left text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">E-mail</th>
              <th className="text-left text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">Setor</th>
              <th className="text-left text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">Perfil</th>
              <th className="text-left text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">Status</th>
              <th className="text-right text-xs font-medium text-portal-gray-500 px-5 py-3 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="border-b border-portal-gray-50 last:border-0 hover:bg-portal-gray-50/50 transition-colors">
                <td className="px-5 py-3.5">
                  <p className="text-sm font-medium text-portal-gray-800 whitespace-nowrap">{user.name}</p>
                </td>
                <td className="px-5 py-3.5">
                  <span className="text-sm text-portal-gray-500 font-mono whitespace-nowrap">{user.cpf}</span>
                </td>
                <td className="px-5 py-3.5">
                  <span className="text-sm text-portal-gray-600 whitespace-nowrap">{user.email}</span>
                </td>
                <td className="px-5 py-3.5">
                  <span className="text-sm text-portal-gray-600 whitespace-nowrap">{user.setor}</span>
                </td>
                <td className="px-5 py-3.5">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                    user.perfil === 'admin'
                      ?'bg-portal-purple-50 text-portal-purple'
                      : 'bg-portal-gray-100 text-portal-gray-600'
                  }`}>
                    {user.perfil === 'admin' ?'Administrador' : 'Colaborador'}
                  </span>
                </td>
                <td className="px-5 py-3.5">
                  <button
                    type="button"
                    onClick={() => onToggleStatus(user.id)}
                    className={`text-xs font-medium px-2 py-1 rounded-full cursor-pointer transition-colors whitespace-nowrap ${
                      user.status === 'ativo'
                        ?'bg-emerald-50 text-emerald-600 hover:bg-emerald-100'
                        : 'bg-red-50 text-red-500 hover:bg-red-100'
                    }`}
                  >
                    {user.status === 'ativo' ?'Ativo' : 'Inativo'}
                  </button>
                </td>
                <td className="px-5 py-3.5">
                  <div className="flex items-center justify-end gap-1">
                    <button
                      type="button"
                      onClick={() => onEdit(user)}
                      title="Editar"
                      className="w-8 h-8 rounded-lg flex items-center justify-center text-portal-gray-400 hover:text-portal-purple hover:bg-portal-purple-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-edit-line text-sm"></i>
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(user)}
                      title="Excluir"
                      className="w-8 h-8 rounded-lg flex items-center justify-center text-portal-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-delete-bin-line text-sm"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
